import React from 'react';
import './BillingCheckbox.css'; // Add this for styling

interface BillingCheckboxProps {
    isChecked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const BillingCheckbox: React.FC<BillingCheckboxProps> = ({ isChecked, onChange }) => {
    return (
        <div className="checkbox-container">
            <input
                type="checkbox"
                id="billingCheckbox"
                checked={isChecked}
                onChange={onChange}
                className="custom-checkbox"
            />
            <label htmlFor="billingCheckbox" className="checkbox-label">
                Use shipping address as billing address
            </label>
        </div>
    );
};

export default BillingCheckbox;
